class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.searchButton = this.querySelector(".search-button");
    this.closeButton = this.querySelector(".close-search");
    this.container = this.querySelector("#predictive-search-container");
    this.connectedCallback();
    this.active = false;
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        if (this.active) this.closeSearch();
      }
    });
  }

  connectedCallback() {
    this.searchButton.addEventListener("click", this.openSearch.bind(this));
    this.closeButton.addEventListener("click", this.closeSearch.bind(this));
  }
  openSearch() {
    this.active = true;
    this.container.classList.add("active");
    document.body.style.overflowY = "hidden";
  }
  closeSearch() {
    this.active = false;
    this.container.classList.remove("active");
    document.body.style.overflowY = "auto";
  }
}

customElements.define("predictive-search", PredictiveSearch);
